export const error = {
    position: 'top-center',
    style: {
        backgroundColor: '#F65C51',
        border: 'none',
        color: '#EBEBF5',
        fontFamily: 'Nunito, sans-serif',
        fontSize: '1rem',
        textAlign: 'center',
        marginTop: '5rem',
    },
    closeStyle: {
        color: '#EBEBF5',
        fontSize: '0.8rem',
    },
}

export const success = {
    position: 'top-center',
    style: {
        backgroundColor: '#71C174',
        border: 'none',
        color: '#EBEBF5',
        fontFamily: 'Nunito, sans-serif',
        fontSize: '1rem',
        textAlign: 'center',
        marginTop: '5rem',
    },
    closeStyle: {
        color: '#EBEBF5',
        fontSize: '0.8rem',
    },
}

export const info = {
    position: 'top-center',
    style: {
        backgroundColor: '#2A99F4',
        border: 'none',
        color: '#EBEBF5',
        fontFamily: 'Nunito, sans-serif',
        fontSize: '1rem',
        textAlign: 'center',
        marginTop: '5rem',
    },
    closeStyle: {
        color: '#EBEBF5',
        fontSize: '0.8rem',
    },
}

export const loginError = {
    position: 'top-center',
    style: {
        backgroundColor: '#F65C51',
        border: 'none',
        color: '#EBEBF5',
        fontFamily: 'Nunito, sans-serif',
        fontSize: '1rem',
        textAlign: 'center',
    },
    closeStyle: {
        color: '#EBEBF5',
        fontSize: '0.8rem',
    },
}